module.exports = __webpack_public_path__ + "static/media/AddRows.5158cca0.gif";